<template>
  <div class="card-form">
    <div class="d-flex flex-row">
      <div style="width: 22%;">
        <el-card>
          <b-dropdown
            block
            variant="success"
            :text="$l('left_card_btn_createNew') || '+ Create New'"
          >
            <b-dropdown-item href="#" @click="newSupplier">
              <span class="left-dropdown-item">
                <i class="el-icon-plus mr-2"></i>
                {{ $l('tips_add_supplier') || '新增供应商' }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item href="#" @click="editContact('add', '')">
              <span class="left-dropdown-item">
                <i class="el-icon-postcard mr-2"></i>
                {{ $l('tips_add_contact') || '新增名片' }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item href="#" @click="editVisitDetail('add')">
              <span class="left-dropdown-item">
                <i class="el-icon-map-location mr-2"></i>
                {{ $l('tips_add_visit') || '新增拜访记录' }}
              </span>
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" @click="uploadImage">
              <span class="left-dropdown-item">
                <i class="el-icon-picture-outline mr-2"></i>
                {{ $l('tips_add_file') || '上传文件' }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
          <b-list-group class="mt-3">
            <b-list-group-item
              href="#"
              :active="isShowScmInfo"
              @click="changeRightShow('showScmInfo')"
              class="d-flex justify-content-between align-items-center left-group-item"
            >
              <div>
                <i class="fa fa-random mr-2"></i>
                {{ $l('left_card_list_mySupplier') || '我的供应商' }}
              </div>
              <b-badge variant="success"></b-badge>
            </b-list-group-item>
            <b-list-group-item
              href="#"
              :active="isShowMyVisit"
              @click="changeRightShow('showMyVisit')"
              class="d-flex justify-content-between align-items-center left-group-item"
            >
              <div>
                <i class="fa fa-map-signs mr-2"></i>
                {{ $l('left_card_list_myVisits') || '我的拜访记录' }}
              </div>
              <b-badge variant="danger"></b-badge>
            </b-list-group-item>
            <b-list-group-item
              href="#"
              :active="isShowMyContacts"
              @click="changeRightShow('showMyContacts')"
              class="d-flex justify-content-between align-items-center left-group-item"
            >
              <div>
                <i class="fa fa-id-card-o mr-2"></i>
                {{ $l('left_card_list_myContacts') || '我的名片夹' }}
              </div>
              <b-badge variant="warning"></b-badge>
            </b-list-group-item>
          </b-list-group>
          <div class="mt-3">
            <h5>
              <b-badge pill variant="secondary">Total</b-badge>
            </h5>
          </div>
          <div class="mt-4">
            <h6 class="text-uppercase">Total Supplier</h6>
            <div class="mt-3">
              <el-progress
                :percentage="formData.supplierPercentage"
                :show-text="false"
              ></el-progress>
            </div>
            <div class="mt-2">
              <p class="text-muted font-12">
                {{ formData.mySuppliers }} Record ({{
                  formData.supplierPercentage
                }}%) of {{ formData.totalSuppliers }} Records
              </p>
            </div>
          </div>
          <div>
            <h6 class="text-uppercase">Total Visit</h6>
            <div class="mt-3">
              <el-progress
                :percentage="formData.visitPercentage"
                status="warning"
                :show-text="false"
              ></el-progress>
            </div>
            <div class="mt-2">
              <p class="text-muted font-12">
                {{ formData.myVisits }} Record ({{ formData.visitPercentage }}%)
                of {{ formData.totalVisits }} Records
              </p>
            </div>
          </div>
          <div>
            <h6 class="text-uppercase">Total Cards</h6>
            <div class="mt-3">
              <el-progress
                :percentage="formData.cardPercentage"
                status="success"
                :show-text="false"
              ></el-progress>
            </div>
            <div class="mt-2">
              <p class="text-muted font-12">
                {{ formData.myCards }} Record ({{ formData.cardPercentage }} %)
                of {{ formData.totalCards }} Records
              </p>
            </div>
          </div>
        </el-card>
      </div>
      <div style="width: 78%; margin-left: 15px">
        <scm-info ref="scmInfo" v-if="isShowScmInfo" />
        <my-visit ref="visit" v-if="isShowMyVisit" />
        <my-contact ref="contact" v-if="isShowMyContacts" />
      </div>
    </div>
    <el-dialog
      ref="newSupplierDialog"
      :title="$l('tips_supplierAdditionMethod') || '供应商新增方式'"
      :visible.sync="supplierFormOption.dialogFormVisible"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      width="800px"
    >
      <new-supplier
        ref="newSupplier"
        @openEditContact="openEditContact"
        @closeDialog="closeDialog"
      ></new-supplier>
    </el-dialog>
    <el-dialog
      ref="editContactDialog"
      @opened="editContactDialogOpened"
      :title="editContactDialogTitle"
      :visible.sync="formOption.contactDialogFormVisible"
      :before-close="contactCancel"
      :close-on-click-modal="false"
      width="1000px"
    >
      <edit-contact
        ref="contactsDetail"
        @success="contactSuccess"
        @addNewCancel="contactCancel"
        :addType="addType"
      ></edit-contact>
    </el-dialog>
    <el-dialog
      ref="uploadImageForm"
      @opened="uploadImageDialogOpened"
      :title="$l('tips_add_file') || '上传文件'"
      :visible.sync="formOption.uploadImageFormVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <upload-image
        ref="uploadImage"
        @uploadImageSuccess="uploadImageSuccess"
      ></upload-image>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    MyContact: () => import('./components/contact/index'),
    ScmInfo: () => import('./components/scminfo/index'),
    MyVisit: () => import('./components/myVisit/index'),
    EditContact: () => import('./components/contact/edit'),
    uploadImage: () => import('./components/scmImages/uploadImage'),
    NewSupplier: () => import('./components/contact/newSupplier')
  },
  data() {
    return {
      editContactDialogTitle: '',
      isShowScmInfo: true,
      isShowMyVisit: false,
      isShowMyContacts: false,
      addType: '',
      formData: {
        myCards: 0,
        totalCards: 0,
        cardPercentage: 0,
        mySuppliers: 0,
        totalSuppliers: 0,
        supplierPercentage: 0,
        myVisits: 0,
        totalVisits: 0,
        visitPercentage: 0
      },
      formOption: {
        title: '',
        contactDialogFormVisible: false,
        uploadImageFormVisible: false
      },
      supplierFormOption: {
        title: '',
        dialogFormVisible: false
      },
      contactData: {}
    }
  },
  mounted() {
    this.getData()
  },
  activated() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .getMySupplierTotalApi({})
        .then((res) => {
          this.formData = res.body
        })
        .catch(() => {
          this.loading = false
        })
    },
    changeRightShow(showType) {
      if (showType === 'showScmInfo') {
        if (this.isShowScmInfo) {
          this.$nextTick(() => {
            this.$refs.scmInfo.reload()
          }, 10)
        }
        this.isShowScmInfo = true
        this.isShowMyVisit = false
        this.isShowMyContacts = false
      }
      if (showType === 'showMyVisit') {
        if (this.isShowMyVisit) {
          this.$nextTick(() => {
            this.$refs.visit.reload()
          }, 10)
        }
        this.isShowScmInfo = false
        this.isShowMyVisit = true
        this.isShowMyContacts = false
      }
      if (showType === 'showMyContacts') {
        if (this.isShowMyContacts) {
          this.$nextTick(() => {
            this.$refs.contact.reload()
          }, 10)
        }
        this.isShowScmInfo = false
        this.isShowMyVisit = false
        this.isShowMyContacts = true
      }
    },
    editContact(type, val) {
      this.contactData = {
        type: type,
        scmInfoUserContactsCode: val
      }
      this.formOption.contactDialogFormVisible = true
      if (type === 'add') {
        this.editContactDialogTitle = this.$l('tips_add_contact') || '编辑名片'
      }
    },
    editContactDialogOpened() {
      this.$refs.contactsDetail.init(this.contactData)
    },
    contactSuccess() {
      this.formOption.contactDialogFormVisible = false
      this.changeRightShow('showMyContacts')
    },
    contactCancel() {
      this.formOption.contactDialogFormVisible = false
    },
    closeDialog() {
      this.supplierFormOption.dialogFormVisible = false
    },
    editVisitDetail(type, val) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-edit',
        params: {
          pageType: type,
          visitCode: val
        }
      })
    },
    uploadImage() {
      this.formOption.uploadImageFormVisible = true
    },
    uploadImageDialogOpened() {
      this.$refs.uploadImage.init('')
    },
    uploadImageSuccess() {
      this.formOption.uploadImageFormVisible = false
    },
    newSupplier() {
      this.addType = 'supplier'
      this.supplierFormOption.title = '供应商新增方式'
      this.supplierFormOption.dialogFormVisible = true
    },
    openEditContact() {
      this.editContact('add', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.left-dropdown-item {
  font-size: 15px;
  font-weight: 400;
}
.left-group-item {
  border: none;
  padding-left: 5px;
  padding-right: 5px;
  height: 52px;
  font-size: 15px;
  color: #6c757d;
}

.table-text {
  color: #6c757d;
  font-size: 14.4px;
}

.text-uppercase {
  color: #6c757d;
  font-size: 12px;
}
.font-12 {
  font-size: 12px;
}
.active {
  font-size: 16px;
  font-weight: 500;
  background-color: #fff;
}
</style>
